/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Interface, type ContractRunner } from "ethers";
import type { TestLargeCall, TestLargeCallInterface } from "../TestLargeCall";

const _abi = [
  {
    inputs: [
      {
        components: [
          {
            internalType: "bytes32[]",
            name: "indexes",
            type: "bytes32[]",
          },
          {
            internalType: "uint256[]",
            name: "resIds",
            type: "uint256[]",
          },
          {
            internalType: "uint256[][]",
            name: "nextIds",
            type: "uint256[][]",
          },
        ],
        internalType: "struct TestLargeCall.CallData",
        name: "data",
        type: "tuple",
      },
    ],
    name: "largeCall",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "testMap",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
] as const;

export class TestLargeCall__factory {
  static readonly abi = _abi;
  static createInterface(): TestLargeCallInterface {
    return new Interface(_abi) as TestLargeCallInterface;
  }
  static connect(
    address: string,
    runner?: ContractRunner | null
  ): TestLargeCall {
    return new Contract(address, _abi, runner) as unknown as TestLargeCall;
  }
}
